import type { FC } from 'react';
import React from 'react';

import type { ForgeUISpaceSettingsExtensionType } from '@confluence/forge-ui/entry-points/types.ts';
import { ForgeKeyboardShortcutVisualizer } from '@confluence/forge-ui/entry-points/ForgeKeyboardShortcut.ts';
import { getAppId } from '@confluence/forge-ui/entry-points/appData.ts';
import { extensionTitle } from '@confluence/forge-ui/entry-points/extensionTitle.ts';
import { SPACE_SETTINGS_FORGE_APPS } from '@confluence/named-routes/entry-points/routes.ts';

import { isForgeAppMatchingRoute } from '../helpers/webItem.ts';

import { ANALYTICS_SOURCE as FORGE_ANALYTICS_SOURCE } from './ForgeAppsLoader.tsx';
import { TabItem } from './TabItem.tsx';
import type { BaseTabsProps } from './WebItemTabs.tsx';
import { ConditionalDropdownItemWrapper } from './WebItemTabs.tsx';

export type ForgeAppsProps = {
	spaceKey: string;
	forgeAppId?: string;
	forgeEnvId?: string;
	forgeRoutePath?: string;
};

export type ForgeAppTabsProps = BaseTabsProps &
	ForgeAppsProps & {
		apps: ForgeUISpaceSettingsExtensionType[];
	};

export const ForgeAppTabs: FC<ForgeAppTabsProps> = ({
	apps,
	setWidth,
	createClickEvent,
	forgeAppId,
	forgeEnvId,
	forgeRoutePath,
	spaceKey,
	isDropdown,
}) => (
	<>
		{apps.map((app: ForgeUISpaceSettingsExtensionType, index: number) => {
			const title = extensionTitle(app);
			const appId = getAppId(app);
			const isSelected = isForgeAppMatchingRoute(app, forgeAppId, forgeEnvId, forgeRoutePath);

			return (
				<ConditionalDropdownItemWrapper key={app.id} condition={isDropdown}>
					<ForgeKeyboardShortcutVisualizer module={app}>
						<TabItem
							key={app.id}
							label={title}
							isSelected={isSelected}
							href={SPACE_SETTINGS_FORGE_APPS.toUrl({
								spaceKey,
								appId,
								envId: app.environmentId,
								forgeManifestRoute: app.properties?.route,
							})}
							onClick={createClickEvent(getAppId(app), FORGE_ANALYTICS_SOURCE)}
							isDropdown={isDropdown}
							index={index}
							setWidth={setWidth}
						/>
					</ForgeKeyboardShortcutVisualizer>
				</ConditionalDropdownItemWrapper>
			);
		})}
	</>
);
